import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	// Step Names (TBD)
	createStepNameNonfinal: {
		defaultMessage: 'Create link',
		id: 'applinks.administration.ui.creation-flow-dialog.create-step-name-nonfinal',
		description: 'Name of the step for creating a new application link.',
	},
	reviewStepNameNonfinal: {
		defaultMessage: 'Review link',
		id: 'applinks.administration.ui.creation-flow-dialog.review-step-name-nonfinal',
		description: 'Name of the step for reviewing the new application link.',
	},
	reciprocalPromptStepNameNonfinal: {
		defaultMessage: 'Create reciprocal link',
		id: 'applinks.administration.ui.creation-flow-dialog.reciprocal-prompt-name-nonfinal',
		description: 'Name of the step for creating a reciprocal application link.',
	},
	connectStepNameNonfinal: {
		defaultMessage: 'Secure connection',
		id: 'applinks.administration.ui.creation-flow-dialog.connect-step-name-nonfinal',
		description: "Name of the step for securing the application link's connection",
	},
	confirmationStepNameNonfinal: {
		defaultMessage: 'Confirmation',
		id: 'applinks.administration.ui.creation-flow-dialog.confirmation-step-name-nonfinal',
		description: 'Name of the step for confirming the new application link.',
	},
	unknownStepNameNonfinal: {
		defaultMessage: 'Configure link',
		id: 'applinks.administration.ui.creation-flow-dialog.unknown-step-name-nonfinal',
		description: 'Name of the step for configuring the application link.',
	},

	// Common
	errorFlagTitle: {
		defaultMessage: 'Failed to configure application link',
		id: 'applinks.administration.ui.creation-flow-dialog.error-flag-title=',
		description: 'Title for the error flag displayed when application link configuration fails.',
	},
	unknownConnectionTypeError: {
		defaultMessage: 'Unknown connection type selected.',
		id: 'applinks.administration.ui.creation-flow-dialog.unknown-connection-type-error',
		description: 'Error message displayed when an unknown connection type is selected.',
	},
	localProductCardHeader: {
		defaultMessage: 'This application',
		id: 'applinks.administration.ui.creation-flow-dialog.local-product-card-header',
		description: 'Header for the local product card in the creation flow dialog.',
	},
	remoteProductCardHeader: {
		defaultMessage: 'Remote application',
		id: 'applinks.administration.ui.creation-flow-dialog.remote-product-card-header',
		description: 'Header for the remote product card in the creation flow dialog.',
	},
	formCancelButtonText: {
		defaultMessage: 'Cancel',
		id: 'applinks.administration.ui.creation-flow-dialog.form-cancel-button-text',
		description: 'Label for button which discards the changes made on the edit page.',
	},
	requiredFieldsText: {
		defaultMessage: 'Required fields are marked with an asterisk',
		id: 'applinks.administration.ui.creation-flow-dialog.required-fields-text',
		description: 'Text indicating that required fields in a form are marked with an asterisk.',
	},

	// Review Stage
	reviewOAuth1HeaderNonfinal: {
		defaultMessage: 'Review OAuth 1.0 link',
		id: 'applinks.administration.ui.creation-flow-dialog.review-oauth-1-header-nonfinal',
		description: 'Header for the review stage of OAuth 1.0 link creation.',
	},
	reviewOAuth2Header: {
		defaultMessage: 'Review OAuth 2.0 link',
		id: 'applinks.administration.ui.creation-flow-dialog.review-oauth-2-header',
		description: 'Header for the review stage of OAuth 2.0 link creation.',
	},
	reviewTunneledHeaderNonfinal: {
		defaultMessage: 'Review tunneled link',
		id: 'applinks.administration.ui.creation-flow-dialog.review-tunneled-header-nonfinal',
		description: 'Header for the review stage of tunneled link creation.',
	},
	reviewIncomingLinkHeaderNonfinal: {
		defaultMessage: 'Review incoming link',
		id: 'applinks.administration.ui.creation-flow-dialog.review-incoming-link-header-nonfinal',
		description: 'Header for the review stage of incoming link creation.',
	},
	reviewOAuth1DescriptionNonfinal: {
		defaultMessage:
			'Confirm the details of the application link you are creating. This will allow the remote <strong>{nameOfRemoteProduct}</strong> to access this {nameOfThisProduct} site. You will later be redirected to {nameOfRemoteProduct} to complete the other side of the link.',
		id: 'applinks.administration.ui.creation-flow-dialog.review-oauth-1-description-nonfinal',
		description:
			'Description explaining the OAuth 1.0 application link review process and what will happen next. {nameOfThisProduct} and {nameOfRemoteProduct} are Atlassian products e.g. Jira, Confluence',
	},
	reviewOAuth2Description: {
		defaultMessage:
			'Confirm the details of the application link you are creating. In the next step, you will exchange credentials to allow the remote <strong>{nameOfRemoteProduct}</strong> to communicate with this {nameOfThisProduct} site.',
		id: 'applinks.administration.ui.creation-flow-dialog.review-oauth-2-description',
		description:
			'Description explaining the OAuth 2.0 application link review process and what will happen next. {nameOfThisProduct} and {nameOfRemoteProduct} are Atlassian products e.g. Jira, Confluence',
	},
	reviewOAuth1ReciprocalDescriptionNonfinal: {
		defaultMessage:
			'The remote <strong>{nameOfRemoteProduct}</strong> application has requested to create a link to this {nameOfThisProduct} site. Review the details below before completing the link. This will allow the remote {nameOfRemoteProduct} to access this site.',
		id: 'applinks.administration.ui.creation-flow-dialog.review-oauth-1-reciprocal-description-nonfinal',
		description:
			'Description explaining the incoming application link review process. {nameOfThisProduct} and {nameOfRemoteProduct} are Atlassian products e.g. Jira, Confluence',
	},
	reviewFormCompleteLinkButtonNonfinal: {
		defaultMessage: 'Complete link',
		id: 'applinks.administration.ui.creation-flow-dialog.review-form-complete-link-button-nonfinal',
		description: 'Label for the button to complete the link creation process.',
	},
	reviewFormCreateLinkButton: {
		defaultMessage: 'Create link',
		id: 'applinks.administration.ui.creation-flow-dialog.review-form-create-link-button',
		description: 'Label for the button to create the link.',
	},

	// Connect (OAuth 2.0)
	connectHeader: {
		defaultMessage: 'Connect to the application',
		id: 'applinks.administration.ui.creation-flow-dialog.connect-header',
		description: 'Header for the connect step in the application link creation flow.',
	},
	connectDescription: {
		defaultMessage:
			'Copy and paste the details below between this page and the settings page of the external application where you configure application links. This creates a secure connection.',
		id: 'applinks.administration.ui.creation-flow-dialog.connect-description',
		description: 'Description explaining how to use the connect applications form.',
	},
	connectContinueButton: {
		defaultMessage: 'Connect',
		id: 'applinks.administration.ui.creation-flow-dialog.connect-continue-button',
		description: 'Label for the button to submit/test the connection process.',
	},
	connectDoLaterButton: {
		defaultMessage: 'Do this later',
		id: 'applinks.administration.ui.creation-flow-dialog.connect-do-later-button',
		description: 'Label for the button to postpone the connection process.',
	},

	// Create
	applicationLinkInformationTextNonfinal: {
		defaultMessage:
			"An application link requires an existing application tunnel or the application's URL. We use either one to connect the application to Jira.",
		id: 'applinks.administration.ui.creation-flow-dialog.application-link-information-text-nonfinal',
		description: 'Info text prior to link that explains what an Applink is.',
	},
	applicationLinkHowToLinkTextNonfinal: {
		defaultMessage: 'How to create an application link',
		id: 'appinks.administration.ui.creation-flow-dialog.application-link-how-to-text-nonfinal',
		description: 'Hyperlink text for the how-to guide in creating an applink.',
	},
	cancelButtonTextNonfinal: {
		defaultMessage: 'Cancel',
		id: 'applinks.administration.ui.creation-flow-dialog.cancel-form-button-text-nonfinal',
		description: 'The button text for cancelling creation of the applink.',
	},
	createHeaderTextNonfinal: {
		defaultMessage: 'Create an application link',
		id: 'applinks.administration.ui.creation-flow-dialog.create-header-text-nonfinal',
		description:
			'Header text for modal dialog for applinks creation flow first step, the creation phase.',
	},
	completeButtonTextNonfinal: {
		defaultMessage: 'Create',
		id: 'applinks.administration.ui.creation-flow-dialog.create-form-button-text-nonfinal',
		description: 'Create button for initializing create locally for applink, on review stage.',
	},
	nextButtonTextNonfinal: {
		defaultMessage: 'Next',
		id: 'applinks.administration.ui.creation-flow-dialog.next-form-button-text-nonfinal',
		description:
			'Next button for continuing creation flow locally for applink, before review stage.',
	},
	reciprocalRedirectButtonTextNonfinal: {
		defaultMessage: 'Finish Setting Up',
		id: 'applinks.administration.ui.creation-flow-dialog.reciprocal-redirect-form-button-text-nonfinal',
		description: 'Redirect button text for sending user to reciprical endpoint for applink setup.',
	},
});
